export const resolveMaintenanceScreenViewedEvent = () => ({
  screen: 'maintenance',
  screen_name: 'maintenance',
  object_name: 'maintenance',
})
